import React, { useEffect, useState } from "react";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import VerifiedIcon from "@mui/icons-material/Verified";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ctscan from "../../assets/icons/ct-scan.png";
import backbone from "../../assets/icons/backbone.png";
import xray from "../../assets/icons/x-ray.png";
import mammography from "../../assets/icons/mammogram.png";
import pet_ct from "../../assets/icons/pet_ct-01.png";
import highMri from "../../assets/icons/mri-high.png";
import nuclear from "../../assets/icons/nuclear.png";
import cardiogram from "../../assets/icons/cardiogram.png";
import ultrasound from "../../assets/icons/technology.png";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";
import abbdox from "../../assets/images/other-pages/AbbaDox-logo.png";
import Faqs from "../Faqs_copy";
import { useLocation } from "react-router-dom";
import bookAppointment from "../../assets/images/other-pages/book_appoint_2.png"
const PatientForms = () => {
  const [examId, setExamId] = useState(null);
  const [openBox, setOpenBox] = useState(false);
  const OpenFullBox = (id) => {
    setOpenBox(!openBox);
    setExamId(id);
  };
  const { hash } = useLocation();

  useEffect(() => {
    // Function to attempt scrolling to the target element
    const scrollToHash = () => {
      if (hash) {
        const targetId = hash.replace("#", "");
        const element = document.getElementById(targetId);
        if (element) {
          // Calculate navbar height (adjust based on your navbar's actual height)
          const navbarHeight = 250; // Adjust this value as needed
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${targetId} not found`);
          // Scroll to top if hash is invalid
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        // Scroll to top if no hash
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    // Initial attempt
    scrollToHash();

    // Retry after a short delay to account for AOS or DOM rendering
    const timer = setTimeout(scrollToHash, 500);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [hash]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    }); // Scroll to the top when the component mounts
  }, []);
  const faqs = [
    {
      question: "How do I get the results of my examination?",
      answer:
        "Your referring physician will have a report from our radiologist usually within 24-48 hours of the completion of your scan unless requested sooner by your physician.",
    },
    {
      question: "How do I get a copy of my films? ",
      answer:
        "We send your films or CDs to your physician, who can provide them to you upon request. If you need an additional copy, please contact us for more information.",
    },
    {
      question: " How long are my records kept on file?",
      answer:
        "We maintain the films and reports from your exams in accordance with state laws.",
    },
  ];
  return (
    <>
    
   <title>Patient Support | Citrus Diagnostic Center Crystal River</title>
   <meta name="description" content="Our center supports patients with comprehensive guidance,imaging services and personalized care to make every visit to Citrus Diagnostic Center smooth and safe."/>
    <div
      className={` text-[#1D1D1F] bg-[#F5F5F7] flex justify-center items-center flex-col relative `}
    >
      <div
        className={` px-4 pb-8 pt-16 sm:px-6 sm:pt-10 md:px-8 md:pt-12 lg:px-10 flex 2xl:w-3/4 xl:w-4/5 w-11/12  slider-wrapper overflow-hidden justify-center relative items-center flex-col lg:pt-16`}
      >
        <div className="text-center my-16 xl:mt-16 ">
          <h1
            data-aos="fade-up"
            className=" font-robout font-black text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[10.25rem] lg:mb-32 md:mb-24 capitalize tracking-[-.04em] leading-tight"
          >
            for patients
          </h1>
        </div>
        <div
          data-aos="fade-up"
          data-aso-delay="100"
          id="appointment"
          className="text-left md:w-11/12 w-full grid xl:grid-cols-2 gap-16"
        >
         <div>
           <h2 className="text-[#d78558] md:text-left text-center sm:text-4xl font-robout text-3xl lg:mb-0 mb-4 font-black">
           Request Appointment
          </h2>
          <p className="font-robout md:text-[1.4rem] md:text-left text-center text-xl font-medium  md:pt-6 pt-2">
            To book and schedule your appointment, give us a call at
            (352) 450-8062 at our office from Monday to Friday during working
            hours (8:30 am - 5 pm).
          </p>
          <p className="font-robout md:text-[1.4rem] text-xl font-medium  py-2">
            Before you schedule an appointment, don’t forget to:
          </p>
          <ul className="pt-3">
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#d78558] font-robout text-3xl font-medium">
                <PlaylistAddCheckCircleIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-[1.3rem] text-lg">
                Inform beforehand regarding cancellation or rescheduling.
              </span>
            </li>
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#d78558] font-robout text-3xl font-medium">
                <PlaylistAddCheckCircleIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-[1.3rem] text-lg">
                Inform our staff about your medical conditions.
              </span>
            </li>
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#d78558] font-robout text-3xl font-medium">
                <PlaylistAddCheckCircleIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-[1.3rem] text-lg">
                Keep us updated about any allergies or medical complications.
              </span>
            </li>
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#d78558] font-robout text-3xl font-medium">
                <PlaylistAddCheckCircleIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-[1.3rem] text-lg">
                Inform about your past examinations and share a copy of it.
              </span>
            </li>
          </ul>
         </div>
         <div className="flex justify-center items-center p-2 ">
          <img src={bookAppointment}  alt="Request an appointment" className="object-cover z-40"/>
         </div>
        </div>
        <div
          data-aos="fade-up"
          data-aso-delay="200"
          className="md:text-left text-center md:w-11/12 w-full my-12"
          id="forms"
        >
          <h2 className="text-[#d78558] sm:text-4xl font-robout text-3xl lg:mb-0 mb-4 font-black">
            Patient Registration Forms
          </h2>
          <p className="font-robout md:text-[1.4rem] text-xl font-medium md:pt-6 pt-2">
            Streamline your check-in process effortlessly by completing the
            following patient forms and bringing the printout of them on your
            scheduled visit.
          </p>
          <div className="grid xl:grid-cols-3 md:grid-cols-2 gap-3 pt-4">
            <div className="flex justify-center items-center p-2">
              <a
                href="./newpatientform.pdf"
                download="New_Patient_Form.pdf"
                className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white  bg-transparent overflow-hidden"
              >
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="flex flex-row gap-2 justify-center items-center ps-3 group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <EditCalendarIcon /> New Patient Form
                  </span>
                  <span className="absolute flex flex-row gap-2 top-0 left-10 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <CloudDownloadIcon /> Download
                  </span>
                </span>
              </a>
            </div>
            <div className="flex justify-center items-center p-2">
              <a
                href="./mripatientform.pdf"
                download="mripatientform.pdf"
                className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white   bg-transparent overflow-hidden"
              >
                <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="flex flex-row gap-2 justify-center items-center ps-3 group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <EditCalendarIcon /> MRI Patient Form
                  </span>
                  <span className="absolute flex flex-row gap-2 top-0 left-10 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <CloudDownloadIcon /> Download
                  </span>
                </span>
              </a>
            </div>
            <div className="flex justify-center items-center p-2">
              <a
                href="./privacypatientform.pdf"
                download="privacy patientform.pdf"
                className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white  bg-transparent overflow-hidden"
              >
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="flex flex-row gap-2 justify-center items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <EditCalendarIcon /> Privacy Patient Form
                  </span>
                  <span className="absolute flex flex-row gap-2 top-0 left-10 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <CloudDownloadIcon /> Download
                  </span>
                </span>
              </a>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aso-delay="300"
          className=" md:w-11/12 w-full mb-12"
          id="insurance"
        >
          <h2 className="text-[#d78558] md:text-left text-center sm:text-4xl font-robout text-3xl lg:mb-0 mb-4 font-black">
            Billing & Medical Coverages
          </h2>

            <ul className="pt-3">
              <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
                <span className="text-[#d78558] font-robout text-3xl font-medium">
                  <VerifiedIcon fontSize="30px" />
                </span>{" "}
                <span className="md:text-xl text-lg">
                  You can pay the bill by cash, check or credit card.
                </span>
              </li>
              <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
                <span className="text-[#d78558] font-robout text-3xl font-medium">
                  <VerifiedIcon fontSize="30px" />
                </span>{" "}
                <span className="md:text-xl text-lg">
                  We have a secure portal for bill payments and inquiries.
                </span>
              </li>
              <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
                <span className="text-[#d78558] font-robout text-3xl font-medium">
                  <VerifiedIcon fontSize="30px" />
                </span>{" "}
                <span className="md:text-xl text-lg">
                  We accept many medical insurance plans (
                  <a
                    className="text-[#d78558] font-bold"
                    href="./cdc_insurance.docx"
                    target="_blank"
                  >
                    View All Accepted Insurance
                  </a>
                  ).
                </span>
              </li>
            </ul>
          </div>
          <div
            data-aos="fade-up"
            data-aso-delay="300"
            className="md:text-left text-center md:w-11/12 w-full mb-12"
            id="abbadox-portal"
          >
            <h2 className="text-[#d78558] sm:text-4xl font-robout text-3xl lg:mb-0 mb-4 font-black">
              AbbaDox® Patient Portal
            </h2>
            <p className="font-robout md:text-[1.4rem] text-xl font-medium  md:pt-6 pt-2">
              AbbaDox® is your patient portal and personal health network that
              enables you to control and organize your healthcare records, track
              your prevention and wellness activities and communicate with your
              health providers. It’s secure and it’s free.
            </p>
            <div>
              <img
                src={abbdox}
                className="py-8 w-80"
                alt="abbdox Logo"
              />
              <a
                href="http://www.abbadoxcareflow.com/"
                target="_blank"
                rel="noreferrer noopener"
                className="group relative inline-flex h-14 mt-3  w-60 items-center rounded-full px-8 font-semibold text-white  bg-transparent overflow-hidden"
              >
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="flex flex-row gap-2 justify-center items-center text-center ps-5 group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <OpenInNewIcon /> Login Here
                  </span>
                  <span className="absolute flex flex-row gap-2 top-0 left-5  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <OpenInNewIcon /> Login Here
                  </span>
                </span>
              </a>
            </div>
          </div>

          {/* Exam Preps */}
          <div className="text-left md:w-11/12 w-full mt-12" id="exam-prep">
            <h2
              data-aos="fade-up"
              data-aso-delay="200"
              className="text-[#d78558] sm:text-4xl font-robout text-3xl lg:mb-0 mb-4 font-black"
            >
              Pre-Exam Preparation
            </h2>
            <p
              data-aos="fade-up"
              data-aso-delay="200"
              className="font-robout md:text-[1.35rem] text-xl font-medium md:pt-6 pt-2"
            >
              Get prepared effectively before attending any diagnostic exams.
              Follow the instructions based on each of the following diagnostic
              tests:
            </p>
            <ul className="pt-3  mt-16">
              {/* 3 */}
              <li
                data-aos="fade-up"
                data-aso-delay="200"
                className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#17f1d1] md:border-none "
              >
                <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                  <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#17f1d1]"></div>
                  <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#17f1d1]"></div>
                  <span className="text-[#a374ff] font-robout text-3xl font-medium">
                    <img src={mammography} className="w-32" alt="2D/3D Mammography" />
                  </span>{" "}
                  <span className="text-[#d78558] text-center  font-robout text-[1.7rem] lg:mb-0 my-4 font-black">
                    2D/3D Mammography
                  </span>
                  <button
                   aria-label="More Details"
                    onClick={() => OpenFullBox(3)}
                    className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8 text-white  font-semibold  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>

                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> More Details
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Open
                      </span>
                    </span>
                  </button>
                </div>
              </li>
              {/* 6 */}
              <li
                data-aos="fade-up"
                data-aso-delay="200"
                className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fc6d1a] md:border-none"
              >
                <div className="flex flex-col h-full justify-center items-center  relative overflow-hidden">
                  <div className="w-[1px] h-[100%] absolute right-[5px] md:block hidden top-[1.2rem] bg-[#fc6d1a]"></div>
                  <div className="absolute right-0 top-0 w-3 h-3 md:block hidden rounded-full bg-[#fc6d1a]"></div>
                  <span className="text-[#fc6d1a] font-robout text-3xl font-medium"></span>{" "}
                  <span className="text-[#d78558] text-center  font-robout text-2xl lg:mb-0 mb-4 font-light"></span>
                </div>
                <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                  <span className="text-[#a374ff] font-robout text-3xl font-medium">
                    <img src={nuclear} className="w-32" alt="Cardiac/Body Nuclear Medicine" />
                  </span>{" "}
                  <span className="text-[#d78558] text-center capitalize  font-robout text-[1.7rem] mt-3  mb-2 font-black">
                    Cardiac/Body Nuclear Medicine
                  </span>
                  <button
                   aria-label=" More Details"
                    onClick={() => OpenFullBox(6)}
                    className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>
                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> More Details
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Open
                      </span>
                    </span>
                  </button>
                </div>
              </li>
              {/* 8 */}
              <li
                data-aos="fade-up"
                data-aso-delay="200"
                className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#ff3fdf] md:border-none "
              >
                <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                  <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#ff3fdf]"></div>
                  <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#ff3fdf]"></div>
                  <span className="text-[#a374ff] font-robout text-3xl font-medium">
                    <img src={xray} className="w-32" alt=" Digital X-Ray" />
                  </span>{" "}
                  <span className="text-[#d78558] text-center capitalize  font-robout text-[1.7rem]  my-2 font-black">
                    Digital X-Ray
                  </span>
                  <button
                   aria-label="More Details"
                    onClick={() => OpenFullBox(4)}
                    className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>
                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> More Details
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Open
                      </span>
                    </span>
                  </button>
                </div>
              </li>

              <li
                data-aos="fade-up"
                data-aso-delay="200"
                className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fd6b6b] md:border-none"
              >
                <div className="flex flex-col h-full justify-center items-center  relative overflow-hidden">
                  <div className="w-[1px] h-[100%] absolute right-[5px] md:block hidden top-[1.2rem] bg-[#fd6b6b]"></div>
                  <div className="absolute right-0 top-0 w-3 h-3 md:block hidden rounded-full bg-[#fd6b6b]"></div>
                  <span className="text-[#a374ff] font-robout text-3xl font-medium"></span>{" "}
                  <span className="text-[#d78558] text-center  font-robout text-2xl lg:mb-0 mb-4 font-light"></span>
                </div>
                <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                  <span className="text-[#ffffff] font-robout text-3xl font-medium">
                    <img src={cardiogram} className="w-32" alt="Echocardiography" />
                  </span>{" "}
                  <span className="text-[#d78558] text-center  font-robout text-[1.7rem] lg:mb-0 my-4 font-black">
                    Echocardiography
                  </span>
                  <button
                    aria-label="More Details"
                    onClick={() => OpenFullBox(5)}
                    className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8 text-white  font-semibold  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>

                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> More Details
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Open
                      </span>
                    </span>
                  </button>
                </div>
              </li>

              {/* 9 */}
              <li
                data-aos="fade-up"
                data-aso-delay="200"
                className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#DAA520] md:border-none "
              >
                <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                  <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#DAA520]"></div>
                  <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#DAA520]"></div>
                  <span className="text-[#004D61] font-robout text-3xl font-medium">
                    <img src={ultrasound} className="w-32" alt=" General/Vascular Ultrasound" />
                  </span>{" "}
                  <span className="text-[#d78558] text-center  font-robout text-[1.7rem] lg:mb-0 my-4 font-black">
                    General/Vascular Ultrasound
                  </span>
                  <button
                    aria-label="More Details"
                    onClick={() => OpenFullBox(9)}
                    className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8 text-white  font-semibold  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>

                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> More Details
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Open
                      </span>
                    </span>
                  </button>
                </div>
              </li>
              {/* 2 */}
              <li
                data-aos="fade-up"
                data-aso-delay="200"
                className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#a7ff6c] md:border-none"
              >
                <div className="flex flex-col h-full justify-center items-center  relative overflow-hidden">
                  <div className="w-[1px] h-[100%] absolute right-[5px] md:block hidden top-[1.2rem] bg-[#a7ff6c]"></div>
                  <div className="absolute right-0 top-0 w-3 h-3 md:block hidden rounded-full bg-[#a7ff6c]"></div>
                  <span className="text-[#a374ff] font-robout text-3xl font-medium"></span>{" "}
                  <span className="text-[#d78558] text-center  font-robout text-2xl lg:mb-0 mb-4 font-light"></span>
                </div>
                <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                  <span className="text-[#a374ff] font-robout text-3xl font-medium">
                    <img src={highMri} className="w-32" alt=" High-Field/Open MRI" />
                  </span>{" "}
                  <span className="text-[#d78558] text-center capitalize  font-robout text-[1.7rem] lg:mb-0 my-4 font-black">
                    High-Field/Open MRI
                  </span>
                  <button
                    aria-label="More Details"
                    onClick={() => OpenFullBox(7)}
                    className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>
                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> More Details
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Open
                      </span>
                    </span>
                  </button>
                </div>
              </li>

              <li
                data-aos="fade-up"
                data-aso-delay="100"
                className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#d78558] md:border-none "
              >
                <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                  <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#d78558]"></div>
                  <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#d78558]"></div>
                  <span className="text-[#ff3fdf] font-robout text-3xl font-medium">
                    <img src={ctscan} className="w-32" alt="Low Dose 160-Slice Open CT" />
                  </span>{" "}
                  <span className="text-[#d78558] text-center capitalize  font-robout text-[1.7rem] lg:mb-0 pt-2 mb-4 font-black">
                    Low Dose 160-Slice Open CT
                  </span>
                  <button
                    aria-label="More Details"
                    onClick={() => OpenFullBox(1)}
                    className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>
                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> More Details
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Open
                      </span>
                    </span>
                  </button>
                </div>
              </li>
              {/* 4 */}
              <li
                data-aos="fade-up"
                data-aso-delay="200"
                className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#a374ff] md:border-none"
              >
                <div className="flex flex-col h-full justify-center items-center  relative overflow-hidden">
                  <div className="w-[1px] h-[100%] absolute right-[5px] md:block hidden top-[1.2rem] bg-[#a374ff]"></div>
                  <div className="absolute right-0 top-0 w-3 h-3 md:block hidden rounded-full bg-[#a374ff]"></div>
                  <span className="text-[#a374ff] font-robout text-3xl font-medium"></span>{" "}
                  <span className="text-[#d78558] text-center  font-robout text-2xl lg:mb-0 mb-4 font-light"></span>
                </div>
                <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                  <span className="text-[#a374ff] font-robout text-3xl font-medium">
                    <img src={backbone} className="w-32" alt="Osteoporosis DEXA Scan" />
                  </span>{" "}
                  <span className="text-[#d78558] text-center  font-robout text-[1.7rem] lg:mb-0 my-4 font-black">
                    Osteoporosis DEXA Scan
                  </span>
                  <button
                    aria-label="More Details"
                    onClick={() => OpenFullBox(2)}
                    className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8 text-white  font-semibold  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>

                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> More Details
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Open
                      </span>
                    </span>
                  </button>
                </div>
              </li>
              <li
                data-aos="fade-up"
                data-aso-delay="100"
                className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#FFC1CC] md:border-none "
              >
                <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                  <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#FFC1CC]"></div>
                  <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#FFC1CC]"></div>
                  <span className="text-[#a374ff] font-robout text-3xl font-medium">
                    <img src={pet_ct} className="w-32" alt=" PET/CT Scan" />
                  </span>{" "}
                  <span className="text-[#d78558] text-center  font-robout text-[1.7rem] lg:mb-0 my-4 md:px-3 xl:px-0 font-bold">
                    PET/CT Scan
                  </span>
                  <button
                    aria-label="More Details"
                    onClick={() => OpenFullBox(8)}
                    className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8 text-white  font-semibold  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>

                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> More Details
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Open
                      </span>
                    </span>
                  </button>
                </div>
              </li>
            </ul>
          </div>
          <div
            data-aos="fade-up"
            data-aso-delay="300"
            className="md:w-11/12 w-full my-16 md:text-left text-center"
            id="patient-rosource"
          >
            <h2 className="text-[#d78558] sm:text-4xl font-robout text-[1.7rem] lg:mb-0 mb-4 font-black">
              Healthcare Resources
            </h2>
            <p className="font-robout md:text-[1.35rem] text-xl font-medium md:pt-6 pt-2">
              For more details regarding the medical conditions you or any of
              your known ones are dealing with, you can refer found from the
              resources below:
            </p>
            <div className="grid  md:grid-cols-2 gap-3 pt-4 sm:p-4">
              <div className="flex justify-center items-center p-2">
                <a
                  href="https://www.radiologyinfo.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <button   aria-label="RADIOLOGYINFO.ORG" className="group relative inline-flex h-14 mt-3 w-[256px] text-white  items-center rounded-full px-8 font-semibold  bg-transparent overflow-hidden">
                    <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>

                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-0 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <EditCalendarIcon /> RADIOLOGYINFO.ORG
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-14 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Visit
                      </span>
                    </span>
                  </button>
                </a>
              </div>
              <div className="flex justify-center items-center p-2">
                <a
                  href="https://www.acr.org/clinical-resources/practice-management/toolkit/patient-resources"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button   aria-label="ACR.ORG" className="group relative inline-flex h-14 mt-3 w-[256px] items-center text-white  rounded-full px-8 font-semibold  bg-transparent overflow-hidden">
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>
                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center ps-10 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <EditCalendarIcon />
                        ACR.ORG
                      </span>
                      <span className="absolute flex flex-row gap-2 top-0 left-14 opacity-0 w-full h-full translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <OpenInNewIcon /> Visit
                      </span>
                    </span>
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aso-delay="400"
            className="text-left md:w-11/12 w-full"
            id="pss"
          >
            
         
            <div className="flex justify-center items-center">
              <div className=" sm:mb-8     ">
                <div className=" font-robout font-bold pb-4 flex items-center lg:pb-0 ">
                  <h2 className="text-[#d78558] sm:text-4xl font-robout md:text-left text-center text-[1.7rem] lg:mb-0 mb-4 font-black">
                    Appointment Confirmation & Cancellation Policy
                  </h2>
                </div>
                <div
                  data-aos="fade-up"
                  className="xl:text-xl md:text-xl sm:text-lg text-lg lg:text-left text-center font-robout"
                >
                  <ul className=" lg:text-left text-center mt-4 md:text-[1.35rem] text-xl font-robout">
                    <li>
                      <span>
                        To help us serve all our patients efficiently, a member
                        of our staff will contact you by phone and/or text a few
                        days prior to your appointment to confirm. If you need
                        to cancel or reschedule, we kindly ask that you notify
                        us at least 24 hours in advance.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>{" "}
            </div>
          </div>
        </div>
        <motion.div
          initial={{
            height: 0,
            clipPath: "ellipse(100% 55% at 48% 44%)",
          }}
          animate={{
            height: openBox ? "100vh" : 0,
            clipPath: openBox
              ? [
                  "ellipse(100% 55% at 48% 44%)",
                  "ellipse(100% 80% at 50% 50%)",
                  "inset(0% 0% 0% 0%)",
                ]
              : [
                  "inset(0% 0% 0% 0%)",
                  "ellipse(100% 80% at 50% 50%)",
                  "ellipse(100% 55% at 48% 44%)",
                ],
          }}
          transition={{
            height: {
              type: "spring",
              stiffness: 200,
              damping: 30,
            },
            clipPath: {
              duration: 1.5,
              ease: "easeInOut",
            },
          }}
          className="w-full bg-[#fafaf6] fixed top-0 z-50  overflow-y-auto"
        >
          <div className={`w-full h-full flex justify-center pt-12 relative`}>
            <div className="absolute md:top-10 top-4 right-8">
              <button
                aria-label="More Details"
                onClick={() => setOpenBox(!openBox)}
                className="group relative inline-flex h-16 mt-3 w-16 items-center rounded-full px-8 font-semibold  bg-transparent overflow-hidden"
              >
                <span className="absolute inset-0 rounded-full bg-[#a374ff] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>

                <span className="relative">
                  <span className="flex  -ml-[1.1rem]  items-center  text-4xl justify-center  group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <CloseIcon fontSize="30px" />
                  </span>
                  <span className="absolute flex items-center  text-4xl justify-center gap-2 -top-1 -left-[1.1rem]  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <CloseIcon fontSize="30px" />
                  </span>
                </span>
              </button>
            </div>
            {examId === 1 ? (
              <div className="lg:w-3/5  w-11/12 text-left">
                <h3 className="text-[#1d1d1f]  font-robout text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                  Low Dose 160-Slice Open CT
                </h3>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    CT/NON-CARDIAC CTA
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Nothing to eat or drink except water 4 hours before the test if it is ordered with IV contrast.",
                      "Drink plenty of water the day before and morning of the test.",
                      "Please wear loose comfortable clothing.",
                      "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
                      "Women should inform technologists if there is any possibility of pregnancy.",
                      "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices and metal containing bras may affect the quality of the test.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    CARDIAC CTA (CORONARY ARTERIES)
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Nothing to eat or drink except water 4 hours before the test if it is ordered with IV contrast.",
                      "Drink plenty of water the day before and morning of the test.",
                      "No caffeine 12 hours before your test.",
                      "Take all medications as usual except Viagra/Cialis/other performance enhancing drugs. If you take blood pressure medicine at night, please take it in the morning instead. Please bring a list of medications to your test.",
                      "Please get the required medications needed to lower your heart rate from your referring doctor before the test.",
                      "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices and metal containing bras may affect the quality of the test.",
                      "Please wear loose, comfortable clothing.",
                      "Inform technologists if you have severe asthma or use inhalers for breathing problems.",
                      "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
                      "Women should inform technologists if there is any possibility of pregnancy.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
            {examId === 2 ? (
              <div className="md:w-3/5  w-11/12 text-left">
                <h3 className="text-[#1d1d1f]  font-robout text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                  Osteoporosis DEXA Scan
                </h3>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    Before the Scan
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Do not take calcium supplements within 24 hours before your test.",
                      "Wear comfortable clothing without metal, buttons or zippers.",
                      "If you had a CT or X-Ray test with IV or oral contrast, schedule your DEXA 7 days after the CT or X-Ray test was performed.",
                      "If you had a recent Nuclear Medicine test, schedule your DEXA at least 7 days after the Nuclear Medicine test was performed.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
            {examId === 3 ? (
              <div className="md:w-3/5  w-11/12 text-left">
                <h3 className="text-[#1d1d1f]  font-robout text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                  2D/3D Mammography
                </h3>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    Before the Scan
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "For your convenience, please wear a two-piece outfit",
                      "Do not use deodorant, powder, or perfume under the arm or breast area.",
                      "Please bring your previous mammogram films from other facilities with you.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
            {examId === 4 ? (
              <div className="md:w-3/5  w-11/12 text-left">
                <h3 className="text-[#1d1d1f]  font-robout text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                  Digital X-Ray
                </h3>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    Before the Scan
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {["Do not wear jewelry or clothing containing metal."].map(
                      (point, i) => (
                        <li key={i} className="mb-2 flex flex-row gap-4">
                          <span className="flex-shrink-0 text-2xl text-[#d78558]">
                            <VerifiedIcon fontSize="30px" />
                          </span>
                          <span className="text-black">{point}</span>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
            ) : null}{" "}
            {examId === 5 ? (
              <div className="md:w-3/5  w-11/12 text-left">
                <h3 className="text-[#1d1d1f]  font-robout text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                  Echocardiography
                </h3>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    Before the Scan
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "You will have to wear comfortable clothes.",
                      "You may be asked by your doctors to fast for 4-6 hours before the scan.",
                      "If the thin tube is used, then you might feel a sore throat, which vanishes after a few hours.",
                      "If you're on any medications, then your doctors will adjust the medicine, especially if you are taking drugs for blood pressure or the heart.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
            {examId === 6 ? (
              <div className="md:w-3/5  w-11/12 text-left">
                <h3 className="text-[#1d1d1f]  font-robout text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                  Nuclear Medicine
                </h3>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    NUCLEAR MEDICINE TESTS
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Drink plenty of water the day before and morning of the test.",
                      "Do NOT wear jewelry or metallic objects.",
                      "Please wear loose, comfortable clothing.",
                      "Inform technologists if you are pregnant or breastfeeding.",
                      "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
                      "No special preparation is required for tests involving the bones, inflammatory, lymphatic, brain, renal and pulmonary systems.",
                      "Tests involving the gastrointestinal system require fasting at least 6-8 hours before the test. Some scans require pre-medicating as preparation.",
                      "Cardiac tests require fasting for at least 4 hours before the test and stress tests require no caffeine for 24 hours before the test.",
                      "Thyroid tests may require stopping certain medications before the test.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    Important Note for PET/Nuclear Medicine Tests
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "The radiopharmaceuticals used for these tests are custom-ordered specifically for your appointment and cannot be canceled or returned within 24 hours of your scheduled exam. Therefore, cancellations or rescheduling for these procedures must be made more than 24 hours in advance to avoid potential charges.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
            {examId === 7 ? (
              <div className="md:w-3/5  w-11/12 text-left overflow-y-auto">
                <h3 className="text-[#1d1d1f] font-robout text-2xl lg:text-3xl lg:mb-0  font-light">
                  High-Field/Open MRI
                </h3>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    MRI
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Nothing to eat or drink except water 4 hours before the test.",
                      "Drink plenty of water the day before and morning of the test.",
                      "You will be asked to change into a gown for the test.",
                      "Please leave all jewelry and metal objects at home.",
                      "Inform technologists of any allergies to radiology contrast or medications.",
                      "Women should inform technologists if there is any possibility of pregnancy.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    PROSTATE/RECTAL/MR ENTEROGRAPHY
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Nothing to eat or drink except water 4 hours before the test.",
                      "Drink plenty of water the day before and morning of the test.",
                      "You will be asked to change into a gown for the test.",
                      "Please leave all jewelry and metal objects at home.",
                      "Inform technologists of any allergies to radiology contrast or medications.",
                      "Drink 10 oz bottle of magnesium citrate the night before the test.",
                      "Take (4) tablets of Dulcolax the night before the test.",
                      "Start a clear liquid diet the night before the test.",
                      "No coffee on the day of the test.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
            {examId === 8 ? (
              <div className="md:w-3/5  w-11/12 text-left">
                <h3 className="text-[#1d1d1f]  font-robout text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                  PET/CT Scan
                </h3>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    PET/CT (FDG)
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Nothing to eat or drink except water 4 hours before the test.",
                      "Drink plenty of water the day before and morning of the test.",
                      "No exercise 24 hours before the test.",
                      "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices, and metal containing bras may affect the quality of the test.",
                      "Please wear loose, comfortable clothing.",
                      "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
                      "Women should inform technologists if there is any possibility of pregnancy.",
                      "This 2-part test takes 1.5–2 hours (Part 1: Injection / Part 2: Pictures).",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    BONE PET/CT (F18 FLUORIDE)
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Drink plenty of water the day before and morning of the test.",
                      "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices, and metal containing bras may affect the quality of the test.",
                      "Please wear loose, comfortable clothing.",
                      "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
                      "Women should inform technologists if there is any possibility of pregnancy.",
                      "This 2-part test takes 1.5–2 hours (Part 1: Injection / Part 2: Pictures).",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    BRAIN AMYLOID PET/CT FOR ALZHEIMER’S DISEASE (VIZAMYL)
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Drink plenty of water the day before and morning of the test.",
                      "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices, and metal containing bras may affect the quality of the test.",
                      "Please wear loose, comfortable clothing.",
                      "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
                      "Women should inform technologists if there is any possibility of pregnancy.",
                      "This 2-part test takes 1.5–2 hours (Part 1: Injection / Part 2: Pictures).",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    PET/CT NEUROENDOCRINE (NETSPOT)
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Nothing to eat or drink except water 4 hours before the test.",
                      "Drink plenty of water the day before and morning of the test.",
                      "No exercise 24 hours before the test.",
                      "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices, and metal containing bras may affect the quality of the test.",
                      "Please wear loose, comfortable clothing.",
                      "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
                      "Women should inform technologists if there is any possibility of pregnancy.",
                      "This 2-part test takes 1.5–2 hours (Part 1: Injection / Part 2: Pictures).",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    PROSTATE PSMA PET/CT (POSLUMA)
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Nothing to eat or drink except water 4 hours before the test.",
                      "Drink plenty of water the day before and morning of the test.",
                      "No exercise 24 hours before the test.",
                      "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices, and metal containing bras may affect the quality of the test.",
                      "Please wear loose, comfortable clothing.",
                      "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
                      "Women should inform technologists if there is any possibility of pregnancy.",
                      "This 2-part test takes 1.5–2 hours (Part 1: Injection / Part 2: Pictures).",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
            {examId === 9 ? (
              <div className="md:w-3/5  w-11/12 text-left">
                <h3 className="text-[#1d1d1f]  font-robout text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                  Ultrasound
                </h3>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    ULTRASOUND ABDOMEN/ABDOMINAL DOPPLER/GALLBLADDER
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "Do not eat or drink anything for six (6) hours before your exam.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    BULBLADDER/PELVIC ULTRASOUND
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {[
                      "2 hours before your test: Empty your bladder.",
                      "1 hour before your test: Drink at least 32 ounces of water (4 cups).",
                      "Your bladder must be full for this test. Do not urinate before the test.",
                    ].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:p-4 p-2">
                  <h4 className="text-[#1d1d1f] font-robout text-2xl font-medium my-2">
                    OTHER ULTRASOUND TESTS
                  </h4>

                  <ul className="md:ps-8 ps-2 text-[#1d1d1f] text-xl font-robout ">
                    {["No preparation required"].map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span className="text-black">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
          </div>
        </motion.div>

      <div
        data-aos="fade-up"
        data-aso-delay="200"
        id="records"
        className="mb-28 px-4 lg:px-10 flex 2xl:w-3/4 xl:w-4/5 w-11/12 "
      >
        <Faqs faqs={faqs} />
      </div>
    </div>
     </>
  );
};

export default PatientForms;
